/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title: shouyin.ts
 * @Package: 南瓜头生鲜收银系统
 * @author: 飞贷金融科技
 * @date: 2025/06/05 11:57:44
 * @version: V1.0
 * @Copyright: 2019 www.feidai.com Inc. All rights reserved.
 * @Belong To: 飞贷金融科技
 * 注意：本内容仅限于深圳中兴飞贷金融科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

const shouyinRouter = [
  {
    path: "/workbench",
    name: "Workbench",
    component: () =>
      // import(/* webpackChunkName: "shouyin" */ '@/views/shouyin/workbench/TemporaryIndex.vue'),
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/workbench/index.vue"
      ),

    meta: {
      title: "工作台",
      deepth: 1,
      keepAlive: true,
    },
  },
  {
    path: "/shopManage",
    name: "ShopManage",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/ShopManage.vue"
      ),
    meta: {
      title: "店铺管理",
      deepth: 1,
    },
  },
  {
    path: "/ai",
    name: "Ai",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/ai.vue"
      ),
    meta: {
      title: "ai助手",
      deepth: 1,
    },
  },
  {
    path: "/statement",
    name: "Statement",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/statement/index.vue"
      ),
    meta: {
      title: "报表",
      deepth: 1,
    },
  },
  {
    path: "/my",
    name: "My",
    component: () =>
      import(/* webpackChunkName: "shouyin" */ "@/views/shouyin/my/index.vue"),
    meta: {
      title: "我的",
      deepth: 1,
    },
  },
  {
    path: "/privacySet",
    name: "PrivacySet",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/my/privacySet/index.vue"
      ),
    meta: {
      title: "隐私设置",
      deepth: 2,
    },
  },
  {
    path: "/aboutUs",
    name: "AboutUs",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/my/aboutUs/index.vue"
      ),
    meta: {
      title: "关于我们",
      deepth: 2,
    },
  },
  {
    path: "/closeAccount",
    name: "CloseAccount",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/my/closeAccount/index.vue"
      ),
    meta: {
      title: "注销账号",
      deepth: 2,
    },
  },
  {
    path: "/addressManage",
    name: "AddressManage",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/my/addressManage/index.vue"
      ),
    meta: {
      title: "收货地址管理",
      deepth: 2,
    },
  },
  {
    path: "/editAddress",
    name: "EditAddress",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/my/editAddress/index.vue"
      ),
    meta: {
      title: "收货地址管理",
      deepth: 2,
    },
  },
  {
    path: "/coreDataDetail",
    name: "CoreDataDetail",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/statement/components/CoreDataDetail.vue"
      ),
    meta: {
      title: "核心数据详情",
      deepth: 2,
    },
  },
  {
    path: "/multiCoreDataDetail",
    name: "MultiCoreDataDetail",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/statement/components/MultiCoreDataDetail.vue"
      ),
    meta: {
      title: "多店核心数据详情",
      deepth: 2,
    },
  },
  {
    path: "/categoryProportionDetail",
    name: "CategoryProportionDetail",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/statement/components/CategoryProportionDetail.vue"
      ),
    meta: {
      title: "类别占比详情",
      deepth: 2,
    },
  },
  {
    path: "/paymentMethodDetail",
    name: "PaymentMethodDetail",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/statement/components/PaymentMethodDetail.vue"
      ),
    meta: {
      title: "付款方式详情",
      deepth: 2,
    },
  },
  {
    path: "/goodsRankingDetail",
    name: "GoodsRankingDetail",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/statement/components/GoodsRankingDetail.vue"
      ),
    meta: {
      title: "商品排行详情",
      deepth: 2,
    },
  },
  {
    path: "/reconciliationDetails",
    name: "ReconciliationDetails",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/statement/reconciliationDetails/index.vue"
      ),
    meta: {
      title: "对账明细",
      deepth: 2,
    },
  },
  {
    path: "/storedValueDetails",
    name: "StoredValueDetails",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/statement/storedValueDetails/index.vue"
      ),
    meta: {
      title: "储值明细",
      deepth: 2,
    },
  },
  {
    path: "/transactionDetail",
    name: "TransactionDetail",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/statement/components/TransactionDetail.vue"
      ),
    meta: {
      title: "交易明细详情",
      deepth: 2,
    },
  },
  {
    path: "/memberAnalysisDetail",
    name: "MemberAnalysisDetail",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/statement/components/MemberAnalysisDetail.vue"
      ),
    meta: {
      title: "会员分析详情",
      deepth: 2,
    },
  },
  {
    path: "/activityDetail",
    name: "activityDetail",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/statement/ActivityDetail/ActivityDetail.vue"
      ),
    meta: {
      title: "活动追踪详情",
      deepth: 2,
    },
  },
  {
    path: "/winningVerifyDetail",
    name: "WinningVerifyDetail",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/statement/components/WinningVerifyDetail.vue"
      ),
    meta: {
      title: "中奖&核销明细",
      deepth: 2,
    },
  },
  {
    path: "/storeInfo",
    name: "StoreInfo",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/my/storeInfo/index.vue"
      ),
    meta: {
      title: "店铺信息",
      deepth: 2,
    },
  },
  {
    path: "/editStoreName",
    name: "EditStoreName",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/my/storeInfo/editStoreName.vue"
      ),
    meta: {
      title: "编辑店铺名称",
      deepth: 2,
    },
  },
  {
    path: "/editCompanyName",
    name: "EditCompanyName",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/my/storeInfo/editCompanyName.vue"
      ),
    meta: {
      title: "编辑公司名称",
      deepth: 2,
    },
  },
  {
    path: "/editStoreAddress",
    name: "EditStoreAddress",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/my/storeInfo/editStoreAddress.vue"
      ),
    meta: {
      title: "我的地址",
      deepth: 2,
    },
  },
  {
    path: "/newCCXstore",
    name: "NewCCXstore",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/my/newCCXstore/index.vue"
      ),
    meta: {
      title: "常常鲜微店",
      deepth: 2,
    },
  },
  {
    path: "/messageManage",
    name: "MessageManage",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/messageManage/index.vue"
      ),
    meta: {
      title: "消息中心",
      deepth: 2,
    },
  },
  {
    path: "/couponManage",
    name: "CouponManage",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/couponManage/index.vue"
      ),
    meta: {
      title: "卡券管理",
      deepth: 2,
      keepAlive: true,
    },
  },
  {
    path: "/couponDetail",
    name: "CouponDetail",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/couponManage/detail.vue"
      ),
    meta: {
      title: "优惠券详情",
      deepth: 2,
    },
  },
  {
    path: "/editPhone",
    name: "EditPhone",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/my/newCCXstore/editPhone.vue"
      ),
    meta: {
      title: "微店联系电话",
      deepth: 3,
    },
  },
  {
    path: "/editBusinessTime",
    name: "EditBusinessTime",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/my/newCCXstore/editBusinessTime.vue"
      ),
    meta: {
      title: "微店营业时间",
      deepth: 3,
    },
  },
  {
    path: "/editPickupTime",
    name: "EditPickupTime",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/my/newCCXstore/editPickupTime.vue"
      ),
    meta: {
      title: "到店提货时间",
      deepth: 3,
    },
  },
  {
    path: "/personAccountCenter",
    name: "PersonAccountCenter",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/my/personAccountcenter/index.vue"
      ),
    meta: {
      title: "个人账号中心",
      deepth: 2,
    },
  },
  {
    path: "/changeMobile",
    name: "ChangeMobile",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/my/changeMobile/index.vue"
      ),
    meta: {
      title: "修改手机号码",
      deepth: 3,
    },
  },
  {
    path: "/changePwd",
    name: "ChangePwd",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/my/changePwd/index.vue"
      ),
    meta: {
      title: "修改密码",
      deepth: 3,
    },
  },
  {
    path: "/setPwd",
    name: "SetPwd",
    component: () =>
      import(
        /* webpackChunkName: "shouyin" */ "@/views/shouyin/my/setPwd/index.vue"
      ),
    meta: {
      title: "设置密码",
      deepth: 3,
    },
  },
];

export default shouyinRouter;
